// Multi-language translations for TA CLÉ INVEST
// Voice: distinctive, warm, Turkish-rooted. Weaves the "key / threshold" motif
// (TA CLÉ = the key) with concrete real-estate craft — deliberately different
// from the parent holding's "quiet Swiss capital" tone.

export const TRANSLATIONS = {
  tr: {
    nav: {
      about: "Kimliğimiz",
      services: "Hizmetler",
      projects: "Portföy",
      testimonials: "Yatırımcı Sözü",
      team: "Kadro",
      insights: "Perspektif",
      faq: "SSS",
      contact: "İletişim",
      cta: "Bir sohbet başlat",
    },
    hero: {
      overline: "İstanbul · Marmara · Ege",
      title_a: "Türk gayrimenkulünün",
      title_b: "anahtar konumu.",
      lede: "Ticari araziler, endüstriyel bölgeler, seçkin konut varlıkları ve Ege sahilinde imza villalar. TA Clé Invest, gayrimenkulü satın alınacak bir varlık olarak değil; kira getirisini, arazi değerini ve mimari kaliteyi bir arada büyüten bir yatırım disiplini olarak inşa eder.",
      primary_cta: "Fırsatı görüşelim",
      secondary_cta: "Portföyü keşfet",
      stat_1: { value: "MMXXI", label: "Kuruluş yılı" },
      stat_2: { value: "7", label: "Türk ili" },
      stat_3: { value: "Ege", label: "İmza villa hattı" },
      stat_4: { value: "3", label: "Yatırım kaldıracı" },
    },
    about: {
      overline: "Bakış",
      title: "Doğru toprak, doğru zaman, doğru mimari.",
      quote: "Anahtar sadece bir kapıyı açmaz — bir zamanlamayı da açar. Gayrimenkul, yıllar içinde ödüllendiren tek yatırım sınıfıdır; sabırla bir araya getirilirse.",
      body_1: "TA Clé Invest, İstanbul merkezli bir gayrimenkul yatırım ve finans şirketidir. Marmara ve Ege koridorlarında ticari araziler ile endüstriyel bölgeleri elde tutuyor, seçilmiş konut varlıklarını uzun vadeli kira portföyüne dönüştürüyoruz.",
      body_2: "Aynı zamanda Güney Ege sahilinde, sınırlı sayıda özel villa geliştirmesinin arkasındayız — mimari detay, malzeme kalitesi ve manzarayı aynı özenle yürüten bir sahil adresi.",
      pillar_1: { title: "Konum", body: "Türkiye'nin büyüme koridorlarında araziyi ve mülkü stratejik olarak konumlandırıyoruz." },
      pillar_2: { title: "Zamanlama", body: "Döngüleri kovalamıyoruz; toprağın ve piyasanın kendi ritmini okuyoruz." },
      pillar_3: { title: "Mimari", body: "Ege villalarımızdan İstanbul ofislerimize — detayı ciddiye alan yürütme." },
      pillar_4: { title: "Getiri", body: "Kira, arazi ve satış: üç kaldıracı tek portföy stratejisinde birleştiriyoruz." },
    },
    services: {
      overline: "Ne yapıyoruz",
      title: "Dört kaldıraç. Tek yatırım tezgâhı.",
      items: [
        { title: "Arazi Portföyü", body: "Marmara ve Ege koridorlarında endüstriyel ve ticari arazi konumlandırması. Uzun vadeli değer birikimi için tutulan pozisyonlar." },
        { title: "Ticari Gayrimenkul", body: "İstanbul'un merkezi iş koridorunda kurumsal kiracılara yönelik prime ofis ve karma kullanım varlıkları." },
        { title: "Villa Geliştirme", body: "Güney Ege'de sınırlı sayıda özel konut. Mimari, iç mekân ve peyzajla birlikte yürütülen imza projeler." },
        { title: "Finans & Yapılandırma", body: "Yatırım ortaklıkları, sermaye yapısı ve kurumsal düzey yönetim danışmanlığı." },
      ],
    },
    projects: {
      overline: "Portföy",
      title: "Mekâna dönüşen bir yatırım tezi.",
      view_all: "Tüm mülkler",
      filters: { all: "Tümü", residential: "Konut", commercial: "Ticari", land: "Arazi", mixed: "Karma" },
    },
    testimonials: {
      overline: "Yatırımcı sözü",
      title: "Uzun ilişkiler, sade cümlelerle.",
    },
    team: {
      overline: "Kadro",
      title: "Sahaya yakın, kurula sadık.",
    },
    insights: {
      overline: "Perspektif",
      title: "Türk gayrimenkulüne dair düşünceler.",
      read_more: "Yazıyı oku",
    },
    faq: {
      overline: "Sıkça sorulanlar",
      title: "Sohbetten önce, birkaç net cevap.",
    },
    contact: {
      overline: "İletişim",
      title: "Bir kahve, bir masa, bir yatırım fırsatı.",
      lede: "İstanbul'daki merkezimize gelin ya da doğrudan hello@tacleinvest.com adresine yazın. Her mesaj kişisel olarak yanıtlanır.",
      form: {
        name: "Ad Soyad",
        email: "E-posta",
        phone: "Telefon (opsiyonel)",
        interest: "İlgi alanı",
        interest_options: ["Yatırım fırsatları", "Villa projesi", "Ticari mülk", "Arazi", "Basın", "Diğer"],
        message: "Mesajınız",
        submit: "Gönder",
        sending: "Gönderiliyor…",
        success: "Mesajınız alındı. Kısa süre içinde döneceğiz.",
        error: "Bir sorun oluştu. Lütfen tekrar deneyin.",
      },
      address_title: "Merkez",
      address: "Büyükdere Cd. 175/6, Ferko Signature, Esentepe, Şişli 34394 İstanbul, Türkiye",
      email_label: "E-posta",
      phone_label: "Telefon",
    },
    footer: {
      tagline: "Türk gayrimenkulünün anahtar konumu.",
      rights: "Tüm hakları saklıdır.",
      quick_links: "Hızlı Bağlantılar",
      contact_label: "İletişim",
      registered: "İstanbul'da tescilli anonim şirket. Esentepe, Şişli.",
    },
    group: {
      overline: "Grup Şirketi",
      title: "Bir İsviçre yatırım holdinginin desteğiyle.",
      body: "TA Clé Invest, Zug merkezli İsviçre yatırım holdingi De Almeda Seligmann Capital AG'nin portföyündeki gayrimenkul yatırım ve finans platformudur. İsviçre yönetimi ile Türk gayrimenkul zanaatını, uzun ömürlü ve nesillerarası bir vizyonla birleştiriyoruz.",
      location: "Zug, İsviçre",
      visit_cta: "dealmedaseligmann.ch",
      pillars: [
        { title: "İsviçre yönetimi", body: "Zug'da tescilli; kurumsal düzeyde şeffaflık ve raporlama standartlarına bağlı." },
        { title: "Uzun vadeli operatör", body: "Çeyreklerle değil, nesillerle düşünen sabırlı sermaye — gayrimenkul böyle inşa edilir." },
        { title: "Küresel erişim", body: "Kökleri Türkiye'de, sermaye ufku Avrupa, MENA ve ötesine uzanır." },
      ],
    },
  },

  en: {
    nav: { about: "Identity", services: "Services", projects: "Portfolio", testimonials: "Investor voice", team: "The bench", insights: "Perspective", faq: "FAQ", contact: "Contact", cta: "Start a conversation" },
    hero: {
      overline: "Istanbul · Marmara · Aegean",
      title_a: "The key position",
      title_b: "in Turkish real estate.",
      lede: "Commercial land, industrial zones, curated residential holdings, and a signature villa line on the Aegean. TA Clé Invest treats real estate not as something you buy — but as a discipline that compounds yield, land value and architectural quality inside one portfolio.",
      primary_cta: "Explore an opportunity",
      secondary_cta: "See the portfolio",
      stat_1: { value: "MMXXI", label: "Founded" },
      stat_2: { value: "7", label: "Turkish provinces" },
      stat_3: { value: "Aegean", label: "Signature villa line" },
      stat_4: { value: "3", label: "Investment levers" },
    },
    about: {
      overline: "Point of view",
      title: "Right land. Right moment. Right architecture.",
      quote: "A key doesn't just open a door — it opens a moment. Real estate is the one asset class that pays you back over the years, if it is assembled with patience.",
      body_1: "TA Clé Invest is an Istanbul-headquartered real-estate investment and finance company. We hold commercial and industrial land across the Marmara and Aegean corridors, and turn selected residential assets into long-horizon rental portfolios.",
      body_2: "We are also behind a limited series of private villas on Türkiye's South Aegean coast — a seaside address where architecture, materials and view are worked with the same attention.",
      pillar_1: { title: "Location", body: "Strategic positioning of land and property inside Türkiye's growth corridors." },
      pillar_2: { title: "Timing", body: "We don't chase cycles. We read the rhythm of the land and the market on its own terms." },
      pillar_3: { title: "Architecture", body: "From our Aegean villas to our Istanbul offices — delivery that takes the detail seriously." },
      pillar_4: { title: "Returns", body: "Rent, land, and sale — three levers, held together inside one portfolio thesis." },
    },
    services: {
      overline: "What we do",
      title: "Four levers. One investment workbench.",
      items: [
        { title: "Land Portfolio", body: "Industrial and commercial land positioning along the Marmara and Aegean corridors. Held for long-horizon value accretion." },
        { title: "Commercial Real Estate", body: "Prime office and mixed-use assets on Istanbul's central business corridor, leased to institutional tenants." },
        { title: "Villa Development", body: "A measured number of private residences on the South Aegean. Signature projects worked alongside architecture, interior and landscape." },
        { title: "Finance & Structuring", body: "Investment partnerships, capital structure and institutional-grade governance advisory." },
      ],
    },
    projects: {
      overline: "Portfolio",
      title: "An investment thesis, turned into place.",
      view_all: "All holdings",
      filters: { all: "All", residential: "Residential", commercial: "Commercial", land: "Land", mixed: "Mixed-use" },
    },
    testimonials: { overline: "Investor voice", title: "Long relationships, plainly kept." },
    team: { overline: "The bench", title: "Close to the site. Loyal to the board." },
    insights: { overline: "Perspective", title: "Notes on Turkish real estate.", read_more: "Read the piece" },
    faq: { overline: "Frequently asked", title: "A few clear answers, before the conversation." },
    contact: {
      overline: "Contact",
      title: "A coffee, a table, an opportunity.",
      lede: "Visit our Istanbul office, or write directly to hello@tacleinvest.com. Every message is answered personally.",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone (optional)",
        interest: "Area of interest",
        interest_options: ["Investment opportunities", "Villa project", "Commercial property", "Land", "Press", "Other"],
        message: "Your message",
        submit: "Send message",
        sending: "Sending…",
        success: "Your message has been received. We will be in touch shortly.",
        error: "Something went wrong. Please try again.",
      },
      address_title: "Headquartered",
      address: "Büyükdere Cd. 175/6, Ferko Signature, Esentepe, Şişli 34394 Istanbul, Türkiye",
      email_label: "Email",
      phone_label: "Telephone",
    },
    footer: { tagline: "The key position in Turkish real estate.", rights: "All rights reserved.", quick_links: "Quick Links", contact_label: "Contact", registered: "A joint-stock company registered in Istanbul. Esentepe, Şişli." },
    group: {
      overline: "Part of the Group",
      title: "Backed by a Swiss investment holding.",
      body: "TA Clé Invest is the real-estate investment and finance platform in the portfolio of De Almeda Seligmann Capital AG — a Zug-based Swiss investment holding managing long-life Turkish enterprises with a multi-generational vision. Swiss governance meets Turkish real-estate craftsmanship.",
      location: "Zug, Switzerland",
      visit_cta: "Visit dealmedaseligmann.ch",
      pillars: [
        { title: "Swiss governance", body: "Zug-registered; held to institutional-grade standards of transparency and reporting." },
        { title: "Long-term operator", body: "Patient capital thinking in generations, not quarters — the way real estate should be built." },
        { title: "Global reach", body: "Rooted in Türkiye, with capital ambition spanning Europe, MENA and beyond." },
      ],
    },
  },

  ar: {
    nav: { about: "هويتنا", services: "الخدمات", projects: "المحفظة", testimonials: "أصوات المستثمرين", team: "الفريق", insights: "منظور", faq: "الأسئلة", contact: "تواصل", cta: "ابدأ محادثة" },
    hero: {
      overline: "إسطنبول · مرمرة · بحر إيجه",
      title_a: "المفتاح في",
      title_b: "العقار التركي.",
      lede: "أراضٍ تجارية، ومناطق صناعية، وممتلكات سكنية مختارة، وسلسلة فلل خاصة على ساحل إيجه. TA Clé Invest لا تعامل العقار كشيء يُشترى — بل كانضباط استثماري يجمع بين العائد الإيجاري وقيمة الأرض وجودة العمارة في محفظة واحدة.",
      primary_cta: "استعرض الفرصة",
      secondary_cta: "شاهد المحفظة",
      stat_1: { value: "MMXXI", label: "سنة التأسيس" },
      stat_2: { value: "٧", label: "محافظة تركية" },
      stat_3: { value: "بحر إيجه", label: "خط الفلل" },
      stat_4: { value: "٣", label: "روافع استثمارية" },
    },
    about: {
      overline: "رؤيتنا",
      title: "الأرض الصحيحة، اللحظة الصحيحة، العمارة الصحيحة.",
      quote: "المفتاح لا يفتح باباً فحسب — بل يفتح لحظة. العقار هو فئة الأصول الوحيدة التي تُثيبك على مر السنين، إذا جُمعت بصبر.",
      body_1: "TA Clé Invest شركة استثمار وتمويل عقاري مقرها إسطنبول. نحتفظ بأراضٍ تجارية وصناعية في ممرَي مرمرة وإيجه، ونحوّل أصولاً سكنية مختارة إلى محافظ إيجارية طويلة الأمد.",
      body_2: "كما نقف وراء سلسلة محدودة من الفلل الخاصة على ساحل إيجه الجنوبي — عنوان ساحلي تُعالَج فيه العمارة والمواد والإطلالة بالعناية نفسها.",
      pillar_1: { title: "الموقع", body: "تموضع استراتيجي للأرض والعقار في ممرات النمو التركية." },
      pillar_2: { title: "التوقيت", body: "لا نلاحق الدورات. نقرأ إيقاع الأرض والسوق بشروطهما." },
      pillar_3: { title: "العمارة", body: "من فلل إيجه إلى مكاتب إسطنبول — تنفيذ يأخذ التفاصيل بجدية." },
      pillar_4: { title: "العائد", body: "الإيجار والأرض والبيع — ثلاث روافع في محفظة واحدة." },
    },
    services: {
      overline: "ما نفعله",
      title: "أربع روافع. طاولة استثمار واحدة.",
      items: [
        { title: "محفظة الأراضي", body: "تموضع الأراضي الصناعية والتجارية على ممرَي مرمرة وإيجه، للاحتفاظ طويل الأمد." },
        { title: "العقار التجاري", body: "مكاتب راقية وأصول متعددة الاستخدامات على المحور التجاري المركزي في إسطنبول." },
        { title: "تطوير الفلل", body: "عدد محدود من المساكن الخاصة على بحر إيجه الجنوبي بمعالجة معمارية دقيقة." },
        { title: "التمويل والهيكلة", body: "شراكات استثمارية، هيكل رأس المال، واستشارات حوكمة بمعايير مؤسسية." },
      ],
    },
    projects: { overline: "المحفظة", title: "أطروحة استثمارية، تتحول إلى مكان.", view_all: "كل الممتلكات", filters: { all: "الكل", residential: "سكني", commercial: "تجاري", land: "أراضي", mixed: "متعدد الاستخدامات" } },
    testimonials: { overline: "أصوات المستثمرين", title: "علاقات طويلة، بجُمل بسيطة." },
    team: { overline: "الفريق", title: "قريبون من الأرض. مخلصون للمجلس." },
    insights: { overline: "منظور", title: "ملاحظات حول العقار التركي.", read_more: "اقرأ المقال" },
    faq: { overline: "أسئلة شائعة", title: "أجوبة واضحة، قبل بدء المحادثة." },
    contact: {
      overline: "تواصل",
      title: "قهوة، وطاولة، وفرصة استثمارية.",
      lede: "زُر مكتبنا في إسطنبول أو اكتب مباشرة إلى hello@tacleinvest.com. كل رسالة تُقرأ ويُردّ عليها شخصياً.",
      form: {
        name: "الاسم الكامل",
        email: "البريد الإلكتروني",
        phone: "الهاتف (اختياري)",
        interest: "مجال الاهتمام",
        interest_options: ["فرص استثمارية", "مشروع الفلل", "عقار تجاري", "أراضٍ", "الصحافة", "أخرى"],
        message: "رسالتك",
        submit: "إرسال",
        sending: "جارٍ الإرسال…",
        success: "تم استلام رسالتك. سنعود إليك قريباً.",
        error: "حدث خطأ. حاول مرة أخرى.",
      },
      address_title: "المقر",
      address: "شارع بويوكديري 175/6، فيركو سيغنتشر، إسنتيبي، شيشلي 34394 إسطنبول، تركيا",
      email_label: "البريد",
      phone_label: "الهاتف",
    },
    footer: { tagline: "المفتاح في العقار التركي.", rights: "جميع الحقوق محفوظة.", quick_links: "روابط سريعة", contact_label: "تواصل", registered: "شركة مساهمة مسجلة في إسطنبول. إسنتيبي، شيشلي." },
    group: {
      overline: "جزء من المجموعة",
      title: "بدعم من شركة قابضة استثمارية سويسرية.",
      body: "TA Clé Invest هي منصة الاستثمار والتمويل العقاري ضمن محفظة De Almeda Seligmann Capital AG — شركة قابضة سويسرية مقرها تسوغ تدير شركات تركية طويلة العمر برؤية متعددة الأجيال. حوكمة سويسرية تلتقي بحرفية العقار التركية.",
      location: "تسوغ، سويسرا",
      visit_cta: "زيارة dealmedaseligmann.ch",
      pillars: [
        { title: "الحوكمة السويسرية", body: "مسجَّلة في تسوغ؛ تلتزم بمعايير الشفافية والتقارير المؤسسية." },
        { title: "مشغِّل طويل الأمد", body: "رأس مال صبور يفكر بالأجيال لا بالأرباع — هكذا يُبنى العقار." },
        { title: "امتداد عالمي", body: "متجذرون في تركيا، وطموحنا الرأسمالي يمتد إلى أوروبا والشرق الأوسط وما بعدهما." },
      ],
    },
  },

  ru: {
    nav: { about: "Идентичность", services: "Услуги", projects: "Портфель", testimonials: "Голос инвестора", team: "Команда", insights: "Перспектива", faq: "Вопросы", contact: "Контакты", cta: "Начать разговор" },
    hero: {
      overline: "Стамбул · Мрамор · Эгейское море",
      title_a: "Ключевое положение",
      title_b: "в турецкой недвижимости.",
      lede: "Коммерческая земля, промышленные зоны, отобранные жилые объекты и авторская линия вилл на побережье Эгейского моря. TA Clé Invest воспринимает недвижимость не как то, что покупается, — а как дисциплину, которая складывает вместе арендный доход, стоимость земли и качество архитектуры в одном портфеле.",
      primary_cta: "Рассмотреть возможность",
      secondary_cta: "Посмотреть портфель",
      stat_1: { value: "MMXXI", label: "Год основания" },
      stat_2: { value: "7", label: "Турецких провинций" },
      stat_3: { value: "Эгей", label: "Авторская линия вилл" },
      stat_4: { value: "3", label: "Инвестрычага" },
    },
    about: {
      overline: "Точка зрения",
      title: "Правильная земля. Правильный момент. Правильная архитектура.",
      quote: "Ключ открывает не только дверь — но и момент. Недвижимость — единственный класс активов, вознаграждающий вас годами, если её собирать терпеливо.",
      body_1: "TA Clé Invest — инвестиционно-финансовая компания в сфере недвижимости со штаб-квартирой в Стамбуле. Мы держим коммерческие и промышленные земли на Мраморном и Эгейском коридорах и превращаем избранные жилые объекты в долгосрочные арендные портфели.",
      body_2: "Мы также стоим за ограниченной линией частных вилл на южном эгейском побережье Турции — курортный адрес, где архитектура, материалы и вид проработаны с одинаковой точностью.",
      pillar_1: { title: "Локация", body: "Стратегическое размещение земли и недвижимости в коридорах роста Турции." },
      pillar_2: { title: "Тайминг", body: "Мы не гонимся за циклами. Мы читаем ритм земли и рынка на их условиях." },
      pillar_3: { title: "Архитектура", body: "От эгейских вилл до стамбульских офисов — исполнение, серьёзно относящееся к деталям." },
      pillar_4: { title: "Доходность", body: "Аренда, земля и продажа — три рычага в одной портфельной стратегии." },
    },
    services: {
      overline: "Что мы делаем",
      title: "Четыре рычага. Один инвестиционный стол.",
      items: [
        { title: "Земельный портфель", body: "Промышленные и коммерческие земли на Мраморном и Эгейском коридорах, удерживаемые ради долгосрочной стоимости." },
        { title: "Коммерческая недвижимость", body: "Премиальные офисы и объекты смешанного использования в деловом коридоре Стамбула." },
        { title: "Строительство вилл", body: "Ограниченное число частных резиденций на южном Эгее с тщательной архитектурой и отделкой." },
        { title: "Финансы и структурирование", body: "Инвестиционные партнёрства, структура капитала и институциональное консультирование." },
      ],
    },
    projects: { overline: "Портфель", title: "Инвестиционный тезис, превращённый в место.", view_all: "Все объекты", filters: { all: "Все", residential: "Жилая", commercial: "Коммерческая", land: "Земля", mixed: "Смешанное" } },
    testimonials: { overline: "Голос инвестора", title: "Долгие отношения — простыми словами." },
    team: { overline: "Команда", title: "Рядом с площадкой. Верны совету." },
    insights: { overline: "Перспектива", title: "Заметки о турецкой недвижимости.", read_more: "Читать материал" },
    faq: { overline: "Часто спрашивают", title: "Несколько чётких ответов до разговора." },
    contact: {
      overline: "Контакты",
      title: "Кофе, стол и инвестиционная возможность.",
      lede: "Приезжайте в наш офис в Стамбуле или напишите напрямую на hello@tacleinvest.com. Каждое сообщение получает личный ответ.",
      form: {
        name: "Имя и фамилия",
        email: "Email",
        phone: "Телефон (необязательно)",
        interest: "Область интереса",
        interest_options: ["Инвестиционные возможности", "Проект вилл", "Коммерческая недвижимость", "Земля", "Пресса", "Другое"],
        message: "Ваше сообщение",
        submit: "Отправить",
        sending: "Отправка…",
        success: "Ваше сообщение получено. Мы скоро свяжемся.",
        error: "Что-то пошло не так. Попробуйте снова.",
      },
      address_title: "Штаб-квартира",
      address: "Büyükdere Cd. 175/6, Ferko Signature, Esentepe, Шишли 34394, Стамбул, Турция",
      email_label: "Email",
      phone_label: "Телефон",
    },
    footer: { tagline: "Ключевое положение в турецкой недвижимости.", rights: "Все права защищены.", quick_links: "Быстрые ссылки", contact_label: "Контакты", registered: "Акционерное общество, зарегистрированное в Стамбуле. Esentepe, Шишли." },
    group: {
      overline: "Часть группы",
      title: "Под управлением швейцарского инвестиционного холдинга.",
      body: "TA Clé Invest — платформа инвестиций и финансирования в сфере недвижимости в портфеле De Almeda Seligmann Capital AG, швейцарского инвестиционного холдинга со штаб-квартирой в Цуге, управляющего долгосрочными турецкими предприятиями с многопоколенческой перспективой. Швейцарская дисциплина встречается с турецким мастерством недвижимости.",
      location: "Цуг, Швейцария",
      visit_cta: "Перейти на dealmedaseligmann.ch",
      pillars: [
        { title: "Швейцарское управление", body: "Зарегистрировано в Цуге; следует институциональным стандартам прозрачности и отчётности." },
        { title: "Долгосрочный оператор", body: "Терпеливый капитал, мыслящий поколениями, а не кварталами — именно так строится недвижимость." },
        { title: "Глобальный охват", body: "Корни в Турции, капитальные амбиции распространяются на Европу, MENA и далее." },
      ],
    },
  },

  fr: {
    nav: { about: "Identité", services: "Services", projects: "Portefeuille", testimonials: "Investisseurs", team: "L'équipe", insights: "Perspective", faq: "FAQ", contact: "Contact", cta: "Entamer une conversation" },
    hero: {
      overline: "Istanbul · Marmara · Égée",
      title_a: "La position clé",
      title_b: "dans l'immobilier turc.",
      lede: "Terrains commerciaux, zones industrielles, résidences sélectionnées et une ligne de villas signature sur la côte égéenne. TA Clé Invest n'aborde pas l'immobilier comme un actif à acheter — mais comme une discipline qui compose rendement locatif, valeur foncière et qualité architecturale dans un même portefeuille.",
      primary_cta: "Explorer une opportunité",
      secondary_cta: "Voir le portefeuille",
      stat_1: { value: "MMXXI", label: "Fondée" },
      stat_2: { value: "7", label: "Provinces turques" },
      stat_3: { value: "Égée", label: "Ligne de villas" },
      stat_4: { value: "3", label: "Leviers d'investissement" },
    },
    about: {
      overline: "Point de vue",
      title: "La bonne terre. Le bon moment. La bonne architecture.",
      quote: "Une clé n'ouvre pas seulement une porte — elle ouvre un moment. L'immobilier est la seule classe d'actifs qui vous récompense au fil des années, à condition d'être assemblée avec patience.",
      body_1: "TA Clé Invest est une société d'investissement et de financement immobilier basée à Istanbul. Nous détenons des terrains commerciaux et industriels le long des corridors de Marmara et de la mer Égée, et transformons des actifs résidentiels sélectionnés en portefeuilles locatifs de long terme.",
      body_2: "Nous sommes également à l'origine d'une série limitée de villas privées sur la côte sud de l'Égée — une adresse balnéaire où architecture, matériaux et vue sont travaillés avec la même exigence.",
      pillar_1: { title: "Emplacement", body: "Positionnement stratégique du foncier et de la propriété dans les corridors de croissance turcs." },
      pillar_2: { title: "Timing", body: "Nous ne courons pas après les cycles. Nous lisons le rythme du terrain et du marché à leurs propres conditions." },
      pillar_3: { title: "Architecture", body: "De nos villas égéennes à nos bureaux stambouliotes — une exécution qui prend le détail au sérieux." },
      pillar_4: { title: "Rendement", body: "Loyer, foncier et cession — trois leviers, réunis dans une seule thèse de portefeuille." },
    },
    services: {
      overline: "Ce que nous faisons",
      title: "Quatre leviers. Un seul établi d'investissement.",
      items: [
        { title: "Portefeuille foncier", body: "Positionnement de terrains industriels et commerciaux sur les corridors de Marmara et de l'Égée — détenus pour l'accumulation de valeur à long terme." },
        { title: "Immobilier commercial", body: "Bureaux prime et actifs mixtes sur le corridor central des affaires d'Istanbul, loués à des locataires institutionnels." },
        { title: "Développement de villas", body: "Un nombre mesuré de résidences privées sur l'Égée du Sud — projets signature travaillés avec architecture, intérieur et paysage." },
        { title: "Financement & Structuration", body: "Partenariats d'investissement, structure de capital et conseil en gouvernance de niveau institutionnel." },
      ],
    },
    projects: { overline: "Portefeuille", title: "Une thèse d'investissement devenue lieu.", view_all: "Tous les actifs", filters: { all: "Tous", residential: "Résidentiel", commercial: "Commercial", land: "Foncier", mixed: "Mixte" } },
    testimonials: { overline: "Investisseurs", title: "Des relations longues, tenues sobrement." },
    team: { overline: "L'équipe", title: "Près du terrain. Fidèle au conseil." },
    insights: { overline: "Perspective", title: "Notes sur l'immobilier turc.", read_more: "Lire l'article" },
    faq: { overline: "Questions fréquentes", title: "Quelques réponses claires, avant la conversation." },
    contact: {
      overline: "Contact",
      title: "Un café, une table, une opportunité.",
      lede: "Rendez-vous à notre bureau d'Istanbul, ou écrivez directement à hello@tacleinvest.com. Chaque message reçoit une réponse personnelle.",
      form: {
        name: "Nom complet",
        email: "E-mail",
        phone: "Téléphone (facultatif)",
        interest: "Domaine d'intérêt",
        interest_options: ["Opportunités d'investissement", "Projet de villa", "Immobilier commercial", "Foncier", "Presse", "Autre"],
        message: "Votre message",
        submit: "Envoyer",
        sending: "Envoi…",
        success: "Votre message a bien été reçu. Nous vous répondrons rapidement.",
        error: "Un problème est survenu. Veuillez réessayer.",
      },
      address_title: "Siège social",
      address: "Büyükdere Cd. 175/6, Ferko Signature, Esentepe, Şişli 34394 Istanbul, Türkiye",
      email_label: "E-mail",
      phone_label: "Téléphone",
    },
    footer: { tagline: "La position clé dans l'immobilier turc.", rights: "Tous droits réservés.", quick_links: "Liens rapides", contact_label: "Contact", registered: "Société anonyme immatriculée à Istanbul. Esentepe, Şişli." },
    group: {
      overline: "Membre du Groupe",
      title: "Soutenu par un holding d'investissement suisse.",
      body: "TA Clé Invest est la plateforme d'investissement et de financement immobilier du portefeuille de De Almeda Seligmann Capital AG — un holding suisse basé à Zoug qui gère des entreprises turques de long terme avec une vision multi-générationnelle. La discipline suisse rencontre le savoir-faire immobilier turc.",
      location: "Zoug, Suisse",
      visit_cta: "Visiter dealmedaseligmann.ch",
      pillars: [
        { title: "Gouvernance suisse", body: "Enregistré à Zoug ; soumis à des standards institutionnels de transparence et de reporting." },
        { title: "Opérateur de long terme", body: "Un capital patient qui pense en générations, pas en trimestres — la façon dont l'immobilier se construit." },
        { title: "Portée mondiale", body: "Enraciné en Türkiye, avec une ambition capitalistique qui s'étend à l'Europe, au MENA et au-delà." },
      ],
    },
  },

  zh: {
    nav: { about: "关于我们", services: "服务", projects: "投资组合", testimonials: "投资人评价", team: "团队", insights: "洞察", faq: "常见问题", contact: "联系", cta: "开始对话" },
    hero: {
      overline: "伊斯坦布尔 · 马尔马拉 · 爱琴海",
      title_a: "土耳其房地产的",
      title_b: "关键位置。",
      lede: "商业用地、工业区、精选住宅资产,以及爱琴海岸的品牌别墅系列。TA Clé Invest 不把房地产当作待购的资产,而是作为一种纪律——在同一个投资组合内,同时复合租金收益、土地价值与建筑品质。",
      primary_cta: "探索机会",
      secondary_cta: "查看投资组合",
      stat_1: { value: "MMXXI", label: "成立年份" },
      stat_2: { value: "7", label: "土耳其省份" },
      stat_3: { value: "爱琴海", label: "别墅系列" },
      stat_4: { value: "3", label: "投资杠杆" },
    },
    about: {
      overline: "视角",
      title: "对的土地。对的时机。对的建筑。",
      quote: "钥匙不仅打开一扇门——它也打开一个时刻。房地产是唯一一种,如果以耐心组合,能以年为单位持续回报的资产类别。",
      body_1: "TA Clé Invest 是一家总部位于伊斯坦布尔的房地产投资与金融公司。我们在马尔马拉与爱琴海走廊持有商业与工业用地,并将精选的住宅资产转化为长期租赁组合。",
      body_2: "我们也是土耳其南爱琴海岸一系列限量私人别墅的开发者——一处用同样精细的态度处理建筑、材料与景观的海滨地址。",
      pillar_1: { title: "位置", body: "在土耳其成长走廊内对土地与地产进行战略布局。" },
      pillar_2: { title: "时机", body: "我们不追逐周期。我们按土地与市场自身的节奏来阅读。" },
      pillar_3: { title: "建筑", body: "从爱琴海别墅到伊斯坦布尔办公——认真对待细节的执行。" },
      pillar_4: { title: "回报", body: "租金、土地与出售——三种杠杆,置于同一个组合策略之中。" },
    },
    services: {
      overline: "我们做什么",
      title: "四个杠杆。一张投资工作台。",
      items: [
        { title: "土地组合", body: "沿马尔马拉与爱琴海走廊布局工业与商业用地——为长期价值积累而持有。" },
        { title: "商业地产", body: "位于伊斯坦布尔中央商务走廊的顶级办公与综合用途资产,长期租赁给机构承租人。" },
        { title: "别墅开发", body: "南爱琴海岸有限数量的私人住宅——与建筑、室内与景观共同推进的品牌项目。" },
        { title: "融资与结构化", body: "投资合作伙伴关系、资本结构与机构级治理咨询。" },
      ],
    },
    projects: { overline: "投资组合", title: "一项化为空间的投资论点。", view_all: "全部资产", filters: { all: "全部", residential: "住宅", commercial: "商业", land: "土地", mixed: "综合用途" } },
    testimonials: { overline: "投资人评价", title: "长久的关系,简朴地维系。" },
    team: { overline: "团队", title: "贴近现场,忠于董事会。" },
    insights: { overline: "洞察", title: "关于土耳其房地产的札记。", read_more: "阅读全文" },
    faq: { overline: "常见问题", title: "在正式对话前,几个清晰的答案。" },
    contact: {
      overline: "联系",
      title: "一杯咖啡,一张桌子,一个机会。",
      lede: "欢迎来到我们的伊斯坦布尔办公室,或直接写信至 hello@tacleinvest.com。每一封讯息都会得到亲自回复。",
      form: {
        name: "姓名",
        email: "电子邮箱",
        phone: "电话(选填)",
        interest: "关注领域",
        interest_options: ["投资机会", "别墅项目", "商业地产", "土地", "媒体", "其他"],
        message: "您的讯息",
        submit: "发送",
        sending: "发送中…",
        success: "您的讯息已收到,我们将尽快与您联系。",
        error: "发生错误,请重试。",
      },
      address_title: "总部",
      address: "Büyükdere Cd. 175/6, Ferko Signature, Esentepe, Şişli 34394 伊斯坦布尔, 土耳其",
      email_label: "邮箱",
      phone_label: "电话",
    },
    footer: { tagline: "土耳其房地产的关键位置。", rights: "版权所有。", quick_links: "快速链接", contact_label: "联系", registered: "在伊斯坦布尔注册的股份有限公司。Esentepe, Şişli。" },
    group: {
      overline: "集团成员",
      title: "由瑞士投资控股公司支持。",
      body: "TA Clé Invest 是 De Almeda Seligmann Capital AG 投资组合中的房地产投资与金融平台——这是一家总部位于楚格的瑞士投资控股公司,以多代际视野管理长寿命的土耳其企业。瑞士的治理传统与土耳其的房地产工艺在此相遇。",
      location: "楚格,瑞士",
      visit_cta: "访问 dealmedaseligmann.ch",
      pillars: [
        { title: "瑞士治理", body: "在楚格注册;遵循机构级的透明度与报告标准。" },
        { title: "长期运营者", body: "以代际、而非季度思考的耐心资本——这才是房地产该有的建造方式。" },
        { title: "全球触角", body: "根植于土耳其,资本雄心延伸至欧洲、中东与北非及更远地区。" },
      ],
    },
  },
};

export const LANGUAGES = [
  { code: "tr", label: "TR", name: "Türkçe" },
  { code: "en", label: "EN", name: "English" },
  { code: "fr", label: "FR", name: "Français" },
  { code: "ru", label: "RU", name: "Русский" },
  { code: "zh", label: "ZH", name: "中文" },
  { code: "ar", label: "AR", name: "العربية" },
];

export const RTL_LANGUAGES = ["ar"];
